import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

// CSS for Hero Section and Content Styling
const styles = {
  heroSection: {
    backgroundColor: '#f5faf9',
  },
  heroTitle: {
    fontSize: 'clamp(2.25rem, 5vw, 4rem)',
    fontWeight: 700,
    color: 'var(--sf-navy)',
    fontFamily: "Georgia, 'Times New Roman', serif",
    lineHeight: 1.08,
    marginBottom: '15px',
  },
  heroSubtitle: {
    fontSize: 'clamp(1rem, 1.4vw, 1.2rem)',
    color: 'var(--sf-ink)',
    lineHeight: 1.7,
    maxWidth: '56rem',
    margin: 0,
  },
  sectionTitle: {
    fontSize: 'clamp(1.4rem, 2.4vw, 1.75rem)',
    fontWeight: 700,
    fontFamily: "Georgia, 'Times New Roman', serif",
    color: 'var(--sf-navy)',
    marginTop: '30px',
    marginBottom: '15px',
  },
  sectionText: {
    fontSize: '1rem',
    color: 'var(--sf-ink)',
    lineHeight: '1.75',
    marginBottom: '15px',
  },
  listItem: {
    fontSize: '1rem',
    color: 'var(--sf-ink)',
    lineHeight: '1.7',
    marginBottom: '8px',
  },
};

const Privacy_Policy: React.FC = () => {
  return (
    <div className="sf-privacy-page">
      {/* Hero Section */}
      <section style={styles.heroSection} className="tw-py-[clamp(3rem,6vw,5rem)]">
        <Container className="sf-privacy-container">
          <h1 style={styles.heroTitle}>Privacy Policy</h1>
          <p style={styles.heroSubtitle}>
            At Srisailam Foundation, we are committed to protecting your privacy and ensuring the security of your personal information.
          </p>
        </Container>
      </section>

      {/* Privacy Policy Content */}
      <Container className="sf-privacy-container tw-py-[clamp(2.8rem,5vw,4.4rem)]">
        <Row>
          <Col className="sf-privacy-content">
            <p style={styles.sectionText}>
           This Website is owned and operated by Srisailam Foundation. We recognize that visitors may have concerns about the information they provide to us and how we treat that information. Srisailam Foundation is committed to ensuring that your privacy is protected. We value the trust you place in us. This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you visit our website, interact with our donation forms, or communicate with us. We reserve the right to update or modify this Privacy Policy at any time. The latest version will always be available on our website with the "Effective Date" noted at the top. You should check this page periodically to ensure that you are happy with any changes. This policy is effective from 19/05/2025. </p>

            <p style={styles.sectionText}>
          <b> Personal Information</b> Srisailam Foundation uses its best efforts to respect the privacy of its online visitors. We do not collect personally identifiable information unless it is voluntarily and knowingly provided. You are not required to register or provide personal information to browse our website. </p>

            <h2 style={styles.sectionTitle}>Information We Collect</h2>
            <p style={styles.sectionText}>
              We may collect the following types of personal information from donors, beneficiaries, and users of our services:
            </p>
            <ul>
              <li style={styles.listItem}>Name, Email ID, Phone Number</li>
              <li style={styles.listItem}>PAN or Aadhaar Number (required for issuing 80G receipts/certificates)</li>
              <li style={styles.listItem}>Postal Address</li>
              <li style={styles.listItem}>Donation and payment details submitted through the website for verification.</li>
              <li style={styles.listItem}>Donation Amounts and Dates</li>
              <li style={styles.listItem}>Purpose or remarks associated with donations</li>
              <li style={styles.listItem}>IP address, device type, and browser information (collected via cookies or analytics tools)</li>
            </ul>
            <p style={styles.sectionText}>
              Personal information may be submitted through the website’s donation, contact, volunteer and membership forms. We use this information to process donations, send receipts, and for compliance purposes.
            </p>

            <h2 style={styles.sectionTitle}>Purpose of Data Collection</h2>
            <p style={styles.sectionText}>
              We collect and process personal data for the following purposes:
            </p>
            <ul>
              <li style={styles.listItem}>To process and acknowledge donations</li>
              <li style={styles.listItem}>To issue donation receipts and 80G certificates (as applicable)</li>
              <li style={styles.listItem}>To comply with statutory and legal obligations under the Income Tax Act, 1961</li>
              <li style={styles.listItem}>To send updates, reports, and impact stories to donors (only if consent is given)</li>
              <li style={styles.listItem}>To improve website functionality and donor experience</li>
              <li style={styles.listItem}>To maintain internal records for accounting and audit purposes</li>
            </ul>

            <h2 style={styles.sectionTitle}>Data Sharing and Disclosure</h2>
            <p style={styles.sectionText}>
              We do not sell, trade, or rent personal data to any third parties. We may disclose your information only in the following circumstances:
            </p>
            <ul>
              <li style={styles.listItem}>To government authorities if required under law</li>
              <li style={styles.listItem}>To our Chartered Accountants, auditors, or compliance professionals for statutory reporting</li>
              <li style={styles.listItem}>To our trusted third-party service providers (e.g., email service, payment processors), bound by strict confidentiality agreements</li>
            </ul>

            <h2 style={styles.sectionTitle}>Data Retention</h2>
            <p style={styles.sectionText}>
              We retain donor and transaction data for as long as necessary to:
            </p>
            <ul>
              <li style={styles.listItem}>Fulfil the purposes outlined above</li>
              <li style={styles.listItem}>Comply with legal, accounting, and statutory obligations (e.g., 80G compliance)</li>
            </ul>
            <p style={styles.sectionText}>
              Data is stored securely and accessed only by authorized personnel.
            </p>

            <h2 style={styles.sectionTitle}>Your Rights</h2>
            <p style={styles.sectionText}>
              As a donor or user, you have the right to:
            </p>
            <ul>
              <li style={styles.listItem}>Request access to your data</li>
              <li style={styles.listItem}>Request correction of any inaccurate or incomplete data</li>
              <li style={styles.listItem}>Request deletion of your personal information (subject to legal retention requirements)</li>
              <li style={styles.listItem}>Opt-out of receiving non-essential communications</li>
            </ul>
            <p style={styles.sectionText}>
              To exercise these rights, please email us at <a href="mailto:info@srisailamfoundation.org">info@srisailamfoundation.org</a>.
            </p>

            <h2 style={styles.sectionTitle}>Children’s Privacy</h2>
            <p style={styles.sectionText}>
              We do not knowingly collect data from individuals under the age of 13. If you believe we have inadvertently collected such data, please contact us at <a href="mailto:info@srisailamfoundation.org">info@srisailamfoundation.org</a> for deletion.
            </p>

            <h2 style={styles.sectionTitle}>Donations</h2>
            <p style={styles.sectionText}>
              Donors make payments separately using QR/UPI or bank transfer and may submit donation and payment details through the website for verification. Submitting the form does not itself confirm payment. Donation details are reviewed through the Foundation’s admin verification process; confirmation/receipt communication follows successful verification. If there are any issues with respect to the donation forms, we may contact you using the information provided. We do not release financial or credit card information under any circumstances.
            </p>

            <p style={styles.sectionText}>
              You may also contribute by contacting us directly or sending checks/money orders to:
            </p>
            <p style={styles.sectionText}>
              <strong>Srisailam Foundation</strong><br />
              Address: C/O Madhu Mishra, No: 440/E, Tulsi Nagar, Phase 1, Near Pragati Puram colony, Raebareli, UP 229316<br />
              Phone: +919838580001 / +9194500 08921<br />
              Email: <a href="mailto:info@srisailamfoundation.org">info@srisailamfoundation.org</a>
            </p>

            <h2 style={styles.sectionTitle}>Data Security</h2>
            <p style={styles.sectionText}>
              We are committed to ensuring that your information is secure. We adopt appropriate technical and organizational measures to:
            </p>
            <ul>
              <li style={styles.listItem}>Protect personal data from unauthorized access, disclosure, alteration, or destruction</li>
              <li style={styles.listItem}>Ensure secure communication using SSL encryption</li>
              <li style={styles.listItem}>Limit access to personal data on a need-to-know basis</li>
            </ul>

            <h2 style={styles.sectionTitle}>Opt-Out</h2>
            <p style={styles.sectionText}>
              You may opt out of receiving emails or postal mail from us at any time by emailing us at <a href="mailto:info@srisailamfoundation.org">info@srisailamfoundation.org</a> or writing to us at the above address. Please allow up to three months for changes to take effect.
            </p>

            <h2 style={styles.sectionTitle}>Cookies</h2>
            <p style={styles.sectionText}>
              We may use cookies to collect non-personal data, track site usage, and enhance your experience. Cookies are not harmful and do not access your personal data. Most browsers allow users to disable cookies.
            </p>

            <h2 style={styles.sectionTitle}>External Links</h2>
            <p style={styles.sectionText}>
              Our site may contain links to external websites. Srisailam Foundation is not responsible for the content or privacy practices of these sites. We encourage you to read their privacy policies separately.
            </p>

            <h2 style={styles.sectionTitle}>Notification of Changes</h2>
            <p style={styles.sectionText}>
              We reserve the right to update or modify this Privacy Policy at any time. Any significant changes will be posted on this page. We will notify you via email if your personal data will be used in a materially different manner.
            </p>

            <h2 style={styles.sectionTitle}>Legal Disclaimer</h2>
            <p style={styles.sectionText}>
              We may disclose your personal information if required by law or in response to legal processes.
            </p>

            <h2 style={styles.sectionTitle}>Interactive Features</h2>
            <p style={styles.sectionText}>
              Participation in surveys or quizzes on our site is voluntary. Information collected through these features is used to improve our services and is not shared with third parties.
            </p>

            <h2 style={styles.sectionTitle}>Contact Us</h2>
            <p style={styles.sectionText}>
              For any questions or concerns regarding this policy or our data practices, you may contact us at:
            </p>
            <p style={styles.sectionText}>
              Email: <a href="mailto:info@srisailamfoundation.org">info@srisailamfoundation.org</a><br />
              Phone: +919838580001 / +9194500 08921<br />
              Address: C/O Madhu Mishra, No: 440/E, Tulsi Nagar, Phase 1, Near Pragati Puram colony, Raebareli, UP 229316
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Privacy_Policy;
